// @flow
import React from "react";
import { Link } from "react-router-dom";
import { Navbar, NavItem, Nav } from "react-bootstrap";

class Heading extends React.Component {
  render() {
    return (
      <Navbar style={{ marginBottom: "0" }} collapseOnSelect>
        <Navbar.Header>
          <Navbar.Brand>
            <Link to="/" style={{ paddingTop: "5px", paddingBottom: "5px" }}>
              {this.props.heading ? (
                <img alt="Window Outfitter" height="40" src="/logo.png" />
              ) : (
                <i class="fas fa-arrow-left" style={{ paddingTop: "10px" }} />
              )}
              {/* <img alt="Window Outfitter" height="40" src="/logo.png" /> */}
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav>
            {/* <NavItem eventKey={1} href="/about">
              About
            </NavItem>
            <NavItem eventKey={2} href="/products">
              Gallery
            </NavItem> */}
            {/* <NavItem eventKey={3} href="/contactus">
              ContactUs
            </NavItem> */}
          </Nav>
          {this.props.heading ? (
            <Nav pullRight>
              <NavItem href="#gallery">Gallery</NavItem>
              <NavItem href="#testimonial">Customer Testimonials</NavItem>
              <NavItem href="#contact">Contact Us</NavItem>
            </Nav>
          ) : null}
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default Heading;



// WEBPACK FOOTER //
// ./src/components/Heading.js